export default function RiskManagement() {
  const risks = [
    {
      risk: 'ضعف الحضور',
      action: 'حملة تسويقية',
      responsible: 'مدير المشروع',
      probability: 'متوسط',
      icon: 'ri-user-unfollow-line',
      color: 'bg-yellow-500'
    },
    {
      risk: 'تأخر التمويل',
      action: 'خطط بديلة',
      responsible: 'مدير المشروع / فريق العمل',
      probability: 'منخفض',
      icon: 'ri-money-dollar-circle-line',
      color: 'bg-green-500'
    },
    {
      risk: 'اعتذار أحد الضيوف',
      action: 'قائمة ضيوف بديلة',
      responsible: 'مدير المشروع',
      probability: 'متوسط',
      icon: 'ri-user-received-line',
      color: 'bg-yellow-500'
    }
  ];

  const getProbabilityColor = (probability: string) => {
    switch (probability) {
      case 'منخفض':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'متوسط':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'عالي':
        return 'bg-red-100 text-red-800 border-red-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  return (
    <section className="py-12 md:py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-20">
          <div className="inline-block mb-6">
            <div className="flex items-center gap-3 bg-[#1B5E20]/10 px-6 py-3 rounded-full">
              <i className="ri-shield-check-line text-2xl text-[#1B5E20]"></i>
              <span className="text-sm font-bold text-[#1B5E20]">إدارة المخاطر</span>
            </div>
          </div>
          <h2 className="text-5xl font-bold text-[#1B5E20] mb-6">
            الاستعداد لكل الاحتمالات
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            نحدد المخاطر المحتملة ونضع خطط استباقية لضمان نجاح الملتقى في جميع الظروف
          </p>
        </div>

        {/* Risks Table */}
        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden mb-16">
          {/* بطاقات الجوال */}
          <div className="md:hidden divide-y divide-gray-100">
            {risks.map((item, index) => (
              <div key={index} className="p-4 flex flex-col gap-3">
                <div className="flex items-center gap-3">
                  <div className={`w-10 h-10 ${item.color} rounded-lg flex items-center justify-center flex-shrink-0`}>
                    <i className={`${item.icon} text-lg text-white`}></i>
                  </div>
                  <span className="text-base font-bold text-gray-800">{item.risk}</span>
                </div>
                <div className="flex flex-wrap gap-2 text-sm">
                  <span className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full">{item.action}</span>
                  <span className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full">{item.responsible}</span>
                  <span className={`inline-block px-3 py-1 rounded-full font-bold border ${getProbabilityColor(item.probability)}`}>{item.probability}</span>
                </div>
              </div>
            ))}
          </div>
          {/* جدول الديسكتوب */}
          <div className="hidden md:block overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gradient-to-r from-[#1B5E20] to-[#2E7D32]">
                  <th className="px-6 py-5 text-right text-sm font-bold text-white border-l border-white/20">الخطر</th>
                  <th className="px-6 py-5 text-right text-sm font-bold text-white border-l border-white/20">الإجراء</th>
                  <th className="px-6 py-5 text-right text-sm font-bold text-white border-l border-white/20">المسؤول</th>
                  <th className="px-6 py-5 text-right text-sm font-bold text-white">الاحتمالية</th>
                </tr>
              </thead>
              <tbody>
                {risks.map((item, index) => (
                  <tr key={index} className="border-b border-gray-100 hover:bg-gray-50 transition-colors duration-200">
                    <td className="px-6 py-5 border-l border-gray-100">
                      <div className="flex items-center gap-3">
                        <div className={`w-10 h-10 ${item.color} rounded-lg flex items-center justify-center flex-shrink-0`}>
                          <i className={`${item.icon} text-lg text-white`}></i>
                        </div>
                        <span className="text-base font-bold text-gray-800">{item.risk}</span>
                      </div>
                    </td>
                    <td className="px-6 py-5 border-l border-gray-100">
                      <span className="text-base text-gray-700">{item.action}</span>
                    </td>
                    <td className="px-6 py-5 border-l border-gray-100">
                      <span className="text-base text-gray-700">{item.responsible}</span>
                    </td>
                    <td className="px-6 py-5">
                      <span className={`inline-block px-4 py-2 rounded-full text-sm font-bold border ${getProbabilityColor(item.probability)}`}>
                        {item.probability}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-[#1B5E20] to-[#2E7D32] rounded-2xl p-10 text-white">
            <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-eye-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold mb-4">المراقبة المستمرة</h3>
            <p className="text-white/90 leading-relaxed">
              نراقب جميع المخاطر بشكل دوري ونحدّث خطط الاستجابة حسب المستجدات لضمان سير العمل بسلاسة
            </p>
          </div>

          <div className="bg-gradient-to-br from-[#D4AF37] to-[#B8941F] rounded-2xl p-10 text-white">
            <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-team-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold mb-4">فريق متخصص</h3>
            <p className="text-white/90 leading-relaxed">
              فريق إدارة المخاطر يعمل على مدار الساعة لتحديد أي تحديات محتملة والتعامل معها بكفاءة عالية
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}